export default "__VITE_ASSET__8WwiNcQL__"